import t from '../common/text';

export default (data) => {
    return `
    <div class="Form Identify">
      <div class="FormName">Identify</div>
      <div class="Explain">
        ${t('identify.explain')}
      </div>
      <div class="Fields">
        <div class="Field Email">
          <input
            class="Email"
            type="email"
            placeholder="${t('identify.email_placeholder')}"
            name="user-email"
          />    
          <div class="Tools wp-block-button">
            <button 
              class="
                SendEmail
                wp-block-button__link 
                wp-element-button
              "
              disabled="disabled"
            >
              ${t('identify.submit')}
            </button>
          </div>
        </div>
      </div>
      <div class="Message"></div>          
    </div>
  `;
};
